import styled from "styled-components";
import { Link } from "react-router-dom";

import { PAGE_TITLE } from "../../../constants";

const Title = styled.h1`
  text-align: center;
`;

const Block = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const Item = styled.li`
  padding: 10px;
  margin: 5px 0;

  &:hover {
    background-color: #e0e0e0;
  }
  a {
    display: block;
    font-weight: bold;
    color: black;
    text-decoration: none;
  }
`;

const SideMenu = () => {
  return (
    <>
      <div className="mb-3 text-center">
        <Link to="/">コンテンツ画面を表示</Link>
      </div>
      <Title className="mb-5">管理画面</Title>
      <Block>
        <Item>
          <Link to="/admin/contents-list">{PAGE_TITLE.ContentsListPage}</Link>
        </Item>
        <Item>
          <Link to="/admin/category-list">{PAGE_TITLE.CategoryListPage}</Link>
        </Item>
        <Item>
          <Link to="/admin/tag-list">{PAGE_TITLE.TagListPage}</Link>
        </Item>
        <Item>
          <Link to="/admin/position-list">{PAGE_TITLE.PositionListPage}</Link>
        </Item>
        <Item>
          <Link to="/admin/reference-list">{PAGE_TITLE.ReferenceListPage}</Link>
        </Item>
        <Item>
          <Link to="/admin/affiliate-list">{PAGE_TITLE.AffiliateListPage}</Link>
        </Item>
      </Block>
    </>
  );
};

export default SideMenu;
